import { Box } from '@mui/material';
import React from 'react';
import { ProjectStatus } from 'spw-redux/modules/projects/types';
import { colors } from 'spw-theme';
import WarningIcon from 'spw-static/images/warning-icon-red.svg';
import styled from 'styled-components';

const Tag = styled.span`
  background: ${colors.grayLight};
  border: 1px solid ${colors.veryLightGray};
  border-radius: 12px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  padding: 3px 8px;
  text-transform: uppercase;
  height: 24px;
  box-sizing: border-box;
  margin-right: 8px;
`;

type Props = {
  status?: ProjectStatus;
  showText?: boolean;
  hasMissingBenchmarkData?: boolean;
};

const statusData: Record<ProjectStatus, { text: string; style: any }> = {
  billable: {
    text: 'Project number assigned',
    style: { background: '#E5F7F7', border: '1px solid #51C3C5' },
  },
  draft: {
    text: 'Pitches, working files, exploration',
    style: { background: '#FFF5E6', border: '1px solid #FF9800' },
  },
  template: {
    text: 'Standards for similar projects',
    style: { background: '#EEEEEE', border: '1px solid #959595' },
  },
  benchmark: {
    text: 'Data for comparison purposes',
    style: { background: '#FFFFCC', border: '1px solid #FFE500' },
  },
};

const ProjectStatusTag = ({
  status,
  showText = false,
  hasMissingBenchmarkData,
}: Props) => {
  const { text, style } = statusData?.[status] || {};

  return (
    <Box display="flex" alignItems="center">
      <Box position="relative">
        <Tag style={style}>{status?.toUpperCase() || 'N/A'}</Tag>

        <Box position="absolute" right={-13} top={2}>
          {hasMissingBenchmarkData ? (
            <img src={WarningIcon} width={18} height={18} alt="missing data" />
          ) : (
            <Box width={18} />
          )}
        </Box>
      </Box>
      {showText && text}
    </Box>
  );
};

export default ProjectStatusTag;
